// extracted by mini-css-extract-plugin
export default {"confirmation":"NewOrderComplete_confirmation__6VoWN","buttonGrid":"NewOrderComplete_buttonGrid__yzodh"};